import { useTranslation } from "react-i18next";

import { useTranslationUtils } from "@/hooks/use-translation-utils";

import { Button } from "./ui/button";
import { Sheet, SheetClose, SheetContent, SheetFooter, SheetHeader, SheetTitle } from "./ui/sheet";

export function ConversionTableModal({ modalOpen, closeModal }: { modalOpen: boolean; closeModal: () => void }) {
  const { t } = useTranslation(["common"]);
  const { getCountryName } = useTranslationUtils();

  return (
    <>
      <Sheet open={modalOpen} onOpenChange={closeModal}>
        <SheetContent side="center" className="h-fit">
          <SheetHeader>
            <SheetTitle>
              {t("common:rankings-equivalence")}
            </SheetTitle>
          </SheetHeader>

          <div className="flex justify-center p-4">
            <table className="w-full border-collapse text-nowrap rounded border border-neutral-900 bg-neutral-200 text-center text-neutral-900 [&_*]:border [&_*]:border-neutral-900 [&_*]:p-1">
              <thead>
                <tr>
                  <th colSpan={4} className="font-semibold">
                    {t("common:conversion-table")}
                  </th>
                </tr>
                <tr className="bg-blue-100">
                  <th className="font-semibold italic">{getCountryName("FR")}</th>
                  <th className="font-semibold italic">{getCountryName("DE")}</th>
                  <th className="font-semibold italic">{getCountryName("IT")}</th>
                  <th className="font-semibold italic">{getCountryName("CH")}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1ère série</td>
                  <td rowSpan={5}>LK 1</td>
                  <td>Cat 1</td>
                  <td>N1</td>
                </tr>
                <tr>
                  <td>T60</td>
                  <td>2,1</td>
                  <td rowSpan={4}>N2</td>
                </tr>
                <tr>
                  <td>T100</td>
                  <td>2,2</td>
                </tr>
                <tr>
                  <td>-15</td>
                  <td>2,3</td>
                </tr>
                <tr>
                  <td>-4/6</td>
                  <td>2,4</td>
                </tr>
                <tr>
                  <td>-2/6</td>
                  <td>LK 2</td>
                  <td>2,5</td>
                  <td rowSpan={3}>N3</td>
                </tr>
                <tr>
                  <td>0</td>
                  <td rowSpan={2}>LK 3</td>
                  <td>2,6</td>
                </tr>
                <tr>
                  <td>1/6</td>
                  <td>2,7</td>
                </tr>
                <tr>
                  <td>2/6</td>
                  <td>LK 4</td>
                  <td>2,8</td>
                  <td rowSpan={2}>N4</td>
                </tr>
                <tr>
                  <td>3/6</td>
                  <td>LK 5</td>
                  <td>3,1</td>
                </tr>
              </tbody>
            </table>
          </div>

          <SheetFooter className="justify-end">
            <SheetClose asChild>
              <Button variant="dark" type="button" className="!w-32">
                {t("common:close")}
              </Button>
            </SheetClose>
          </SheetFooter>
        </SheetContent>
      </Sheet>
    </>
  );
}
